import {
  AbstractControl,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';

export const isTrafikLicenseNumber: ValidatorFn =
  Validators.pattern('^DKE\\d{10}$');

export const trafikLicenseNumberValidator: ValidatorFn = (
  control: AbstractControl
): ValidationErrors | null => {
  const regExp = '^DKE\\d{10}$';
  return String(control.value).match(new RegExp(regExp)) || !control.value
    ? null
    : { trafikLicenseNumber: true };
};
